// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","AdformInview__adform":"bav_a bhl_kb"};